import { CountryCode, E164Number } from 'libphonenumber-js';
import React from 'react';
import PhoneInput from 'react-phone-number-input';
import styled, { ThemeContext } from 'styled-components';
import { DISABLE_BROWSER_AUTOFILL_SETTINGS } from '../../utils/disable-auto-complete';
import { Typography } from '../typography';

export interface IPhoneInputFieldProps {
	value?: E164Number;
	onChange?: (value: E164Number | undefined | null) => void;
	defaultCountry?: CountryCode;
	country?: CountryCode;
	onCountryChanged?: (countryCode?: CountryCode) => void;
	placeholder?: string;
	readOnly?: boolean;
	error?: string;
	hideBorder?: boolean;

	onFocus?: () => void;
	onBlur?: () => void;
}

const PhoneInputFieldWrapper = styled.div<{ error: boolean; readOnly?: boolean; hideBorder?: boolean }>`
	.PhoneInputCountry {
		margin-right: -3px;
	}
	input {
		border: ${props => (props.readOnly ? '0px' : `1px solid ${props.error ? props.theme.colors.bad : props.theme.colors.border}`)};
		border-radius: 3px;
		padding: 0.25em 0.5em;
		&::placeholder {
			font-weight: 300;
			color: ${props => props.theme.palette.text.disabled};
		}
		color: ${props => props.theme.colors.font};
		font-size: 0.95rem;
		font-weight: 300;
		width: 100%;
		background-color: none;
		background: none;
		transition: all 0.3s ease-in-out;
		&:focus {
			outline: none !important;
			border: ${props => (props.hideBorder ? 'none' : `1px solid ${props.theme.colors.primary} !important`)};
			transition: all 0.3s ease-in-out !important;
		}
		margin-left: ${props => (props.hideBorder ? '0px' : '10px')};
	}
	.PhoneInputCountryIcon--border {
		background-color: inherit;
		box-shadow: none;
	}
	/*
	.PhoneInputCountryIcon {
		width: inherit;
		height: inherit;
	}*/
	.PhoneInputCountrySelect:focus + .PhoneInputCountryIcon--border {
		box-shadow: none;
		border: none;
	}
	.PhoneInput:focus {
		border: none;
	}
`;

const ErrorMessageWrapper = styled.div`
	p {
		color: ${props => props.theme.colors.bad} !important;
		margin: 0.25em 0;
	}
`;

export const PhoneInputField = ({
	onFocus,
	onBlur,
	value,
	onChange,
	onCountryChanged,
	country,
	defaultCountry,
	placeholder,
	error,
	readOnly,
	hideBorder
}: IPhoneInputFieldProps) => {
	const theme = React.useContext(ThemeContext);
	return (
		<PhoneInputFieldWrapper onFocus={onFocus} onBlur={onBlur} readOnly={readOnly} error={!!error} hideBorder={hideBorder}>
			{!readOnly ? (
				<PhoneInput
					{...DISABLE_BROWSER_AUTOFILL_SETTINGS}
					placeholder={placeholder}
					country={country}
					initialValueFormat="national"
					onCountryChange={c => onCountryChanged?.(c)}
					defaultCountry={defaultCountry as CountryCode}
					flagComponent={props => {
						return <div style={{ color: theme?.colors.font, width: 20 }}>{props.country}</div>;
					}}
					value={value}
					onChange={value => (!readOnly && onChange ? onChange(value ?? null) : null)}
				/>
			) : (
				<Typography variant="body1" style={{ paddingTop: 2 }}>
					{value}
				</Typography>
			)}

			{error ? (
				<ErrorMessageWrapper>
					<Typography variant="body2">{error}</Typography>
				</ErrorMessageWrapper>
			) : (
				<></>
			)}
		</PhoneInputFieldWrapper>
	);
};
